import cloudTypes from 'utility/constants/cloudTypes';

/**
 * Returns a display name for an asset based on its type and product code.
 *
 * @param {string | null} type - The type of the asset (e.g., 'bare metal', 'dedicated', 'cloud', etc.).
 * @param {string} productCode - The product code associated with the asset.
 * @returns {string} The display name for the asset.
 */
const displayName = (type, productCode) => {
	switch (type) {
		case 'bare metal':
			return 'Bare Metal';
		case 'dedicated':
			return 'Dedicated';
		case 'open stack':
			return 'Cloud Server';
		case 'cloud':
		case 'cloud hosting':
			return cloudTypes[productCode] || 'Cloud';
		case 'managed app':
			return 'Managed App';
		case 'private parent':
			return 'Private VPS Parent';
		default:
			return 'Server';
	}
};

export default displayName;
